'use client'
import { useTranslation } from '@/app/i18n/client'
import React, { useState } from 'react'
import CustomErrorBoundary from '../../ErrorBoundary'
import Image from 'next/image'
const Testimonial = () => {
  const { t } = useTranslation()
  const testimonials = [
    {
      user_name: 'Mr René Gacon',
      user_title:
        'Сonsultant to the Company Fruitière, specializes in Logistics',
      content:
        'Throughout my long career, I used the Fructidor, and I especially appreciated its ability to adapt to changing markets. I particularly appreciate its increasing openness internationally, such as Eastern Europe or Asia.',
    },
    {
      user_name: 'Jane Smith',
      user_title: 'Highly Recommend',
      content:
        'Throughout my long career, I used the Fructidor, and I especially appreciated its ability to adapt to changing markets. I particularly appreciate its increasing openness internationally, such as Eastern Europe or Asia.',
    },
    {
      user_name: 'Jane ',
      user_title: 'Highly Recommend',
      content:
        'Throughout my long career, I used theFructidor, and I especially appreciated its ability to adapt to changing markets. I particularly appreciate its increasing openness internationally, such as Eastern Europe or Asia.',
    },
  ]

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0)

  const handleDotClick = (index: number) => {
    setCurrentTestimonialIndex(index)
  }

  return (
    <div className="w-[50%] bg-[#fafafa] flex flex-col items-center  px-[41px] py-[48px] mobile:w-[100%] mobile:p-[20px] mobile:gap-[10px]">
      <h1 className="text-[28px] font-ns_bold mobile:text-center mobile:text-[20px] ">
        {t('Our users Testimonies')}
      </h1>
      <Image
        height={40}
        width={40}
        alt="quote"
        src={'/assets/Icons/quote.svg'}
        className="my-[20px] mobile:m-0"
      />
      <p className="text-sm text-[#4a4a4a] text-center">
        {t(testimonials[currentTestimonialIndex].content)}
      </p>
      <div className="testimonials-container mt-[33px] flex mobile:mt-[20px]">
        <div>
          <div className="imageContainer w-[50px] h-[50px] bg-red-100 rounded-[100px] mr-[10px]"></div>
        </div>
        <div className="testimonial flex flex-col items-center mobile:items-start">
          <div>
            <h3 className="text-[16pxx] text-[#4a4a4a]">
              {testimonials[currentTestimonialIndex].user_name}
            </h3>
            <p className="text-[#4a4a4a] text-xs mt-[6px] w-[200px]">
              {testimonials[currentTestimonialIndex].user_title}
            </p>
          </div>

          <div className="dots-container flex">
            {testimonials.map((testimonial, index) => (
              <CustomErrorBoundary key={index}>
                <div
                  className={`w-[12px] h-[12px] bg-[#fff] flex m-[10px] rounded-[30px] cursor-pointer mt-[17px] shadow-[0_0_9px_0_rgba(0,0,0,0.14)] ${
                    index === currentTestimonialIndex ? 'dot active' : 'dot'
                  }`}
                  key={index}
                  onClick={() => handleDotClick(index)}
                ></div>
              </CustomErrorBoundary>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Testimonial
